module.exports = __webpack_public_path__ + "assets/img/right_3.acb66019.png";